__turbopack_context__.v({
  "metaBlock": "project-spine-module__auJ_Iq__metaBlock",
  "metaGrid": "project-spine-module__auJ_Iq__metaGrid",
  "metaLabel": "project-spine-module__auJ_Iq__metaLabel",
  "metaLeft": "project-spine-module__auJ_Iq__metaLeft",
  "metaOverview": "project-spine-module__auJ_Iq__metaOverview",
  "metaRight": "project-spine-module__auJ_Iq__metaRight",
  "metaSection": "project-spine-module__auJ_Iq__metaSection",
  "metaText": "project-spine-module__auJ_Iq__metaText",
  "metaTools": "project-spine-module__auJ_Iq__metaTools",
  "outputCard": "project-spine-module__auJ_Iq__outputCard",
  "outputGrid": "project-spine-module__auJ_Iq__outputGrid",
  "page": "project-spine-module__auJ_Iq__page",
});
